import { metricKeys } from '@pulse/metrics';

// Keep the rate card's identity while its count toggle displays technical failures.
export const isRateMetric = (metric: string): boolean =>
  metric === metricKeys.VideoPlaybackFailuresTechPer1000PlayingMinutes;

export const getNumericMetric = (metric: string): string =>
  isRateMetric(metric) ? metricKeys.VideoPlaybackFailuresTech : metric;
